<template lang="pug">
.toasts-container
	transition-group(name="toast-transition")
		.toast(v-for="(t, k) in toasts" :key="`${k}-toast`" :class="t.classes || {}")
			.message {{ t.content }}
			button.button.button--ghost.toast-dismiss-button(@click="dismissToast(t)")
				i.fa.fa-times
</template>

<script>
// import Vue from "vue";
// import _ from "lodash";
import MutationTypes from "@/store/mutation-types";
import { EventBus } from "@/event-bus";

export function showSimpleToast(message, base) {
	EventBus.pushGlobalEvent(
		"toasts:new",
		Object.assign(base || {}, {
			content: message
		})
	);
}

export default {
	props: {
		toasts: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	beforeMount() {
		EventBus.onGlobalEvent("toasts:new", t => {
			this.$store.commit(MutationTypes.ADD_TOAST, t);
			t.lifetime = t.lifetime || 5000;
			if (t.classes && t.classes == "is-error") t.lifetime = 0;
			const self = this;
			if (t.lifetime > 0) {
				t.timeoutId = setTimeout(function() {
					self.$store.commit(MutationTypes.DISMISS_TOAST, t);
				}, t.lifetime);
			}
		});
	},
	methods: {
		dismissToast(t) {
			this.$store.commit(MutationTypes.DISMISS_TOAST, t);
		}
	}
};
</script>

<style lang="stylus">
.toasts-container
	/*
	display flex
	flex-direction column
	justify-content flex-end
	align-items flex-end
	*/
	position fixed
	bottom 0
	right 0
	width 500px
	max-width 500px
	z-index 80000

	@media screen and (max-width 500px) {
		max-width calc(100% - 2rem)
	}

	.toast
		position relative
		display flex
		justify-content space-between
		align-items center
		padding 0.5em 0.0em 0.5em 0.8em
		margin-bottom 0.5em
		margin-right 0.5em
		border-radius 0.25em
		background-color rgba(0, 0, 0, 0.8)
		color #fff

		.toast-dismiss-button
			margin 0
			padding 0.5em
			color #fff
			height 100%

//.toast-transition-enter-active, .toast-transition-leave-active
	//transform-origin 100% 100%

.toast-transition-leave-active
	position absolute

.toast-transition-enter
	transform translateY(100%)
	opacity 0

.toast-transition-leave-to
	transform translateX(40rem)
	opacity 0

.toast
	transition all 0.2s ease
</style>
